import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useTeamsStore } from '../../model/teams/store'

/**
 * `DELETE /admin-api/teams/{team}` — remove a team (and detach its user links).
 */
export const useTeamDelete = async (teamId: string | number): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useTeamsStore()

  const url = useAdminRoutes('admin.teams.delete', { team_id: teamId })

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.delete<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return false
    }

    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    store.setSaving(false)
  }
}
